import type { Major, CareerPath } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.majors.descriptionSidebar;

export const useAgentContext = (major: Major, highRelevanceCareerPaths: CareerPath[]) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Major Sidebar — Typical College & Career Paths',
    display: 'Sidebar with a typical-college chip and clickable career-path pill chips',
    detail: [STRINGS.typicalCollegeInfo, STRINGS.careerPathsInfo].join('\n\n'),
    data: {
      typicalCollege: major.typicalCollege,
      careerPaths: highRelevanceCareerPaths.map((cp) => cp.name),
    },
  });
};
